<template>
  <div id="adicionar-equipe">
    <div class="d-flex justify-content-end">
      <button class="btn" @click="showModal()">
        <span><i class="icofont-plus"></i> Adicionar equipe</span>
      </button>
    </div>
    <b-modal
      v-model="modal.enabled"
      hide-footer
      centered
      scrollable
      ref="modal"
      id="modal-adicionar-equipe"
    >
      <template #modal-header>
        <div class="d-flex justify-content-between w-100">
          <span>Adicionar equipe</span>
          <span @click="modal.enabled = false">
            <i class="icofont-close" style="cursor: pointer"></i>
          </span>
        </div>
      </template>
      <div class="body">
        <b-input-group>
          <b-form-input
            id="search-input"
            v-model="searchQuery"
            placeholder="CNES"
          ></b-form-input>
          <b-input-group-append>
            <b-button variant="primary" @click="search"
              ><i class="icofont-search-1"></i> Buscar
              <b-spinner
                small
                label="Small Spinner"
                variant="white"
                v-if="loading"
              ></b-spinner
            ></b-button>
          </b-input-group-append>
        </b-input-group>
        <b-alert
          :show="messageAlert.length > 0"
          variant="warning"
          dismissible
          @dismissed="clearMessageAlert"
          class="mt-2"
        >
          {{ messageAlert }}
        </b-alert>

        <div v-if="modal.text != ''" class="mt-3">
          <ul>
            <li><b>CNES:</b> {{ modal.text.CodigoCNES.codigo }}</li>
            <li><b>UBS:</b> {{ modal.text.nomeFantasia.Nome }}</li>
            <li><b>INE:</b></li>
            <li><b>Latitude:</b> {{ modal.text.Localizacao.latitude }}</li>
            <li><b>Longitude:</b> {{ modal.text.Localizacao.longitude }}</li>
          </ul>
          <div class="d-flex justify-content-end">
            <button class="btn"><i class="icofont-plus"></i> Adicionar</button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: 'AdicionarEquipe',
  data() {
    return {
      modal: {
        enabled: false,
        text: '',
      },
      searchQuery: '',
      messageAlert: '',
      loading: false,
      form: {
        ine: '',
        tipo_equipe: '',
        min_cad: '',
        cad_sisab: '',
        max_cad: '',
      },
    }
  },
  methods: {
    showModal() {
      this.modal.enabled = true
    },
    async search() {
      if (this.searchQuery.trim() === '') {
        this.messageAlert = 'Por favor, insira um CNES para pesquisar.'
        return
      }

      try {
        this.loading = true
        this.modal.text = ''
        const response = await this.$api.get(
          '/app/profissionais-pec-cnes-datasus/estabelecimentos-de-saude/' +
            this.searchQuery
        )
        if (response != undefined) {
          this.modal.text = response.data.DadosGeraisEstabelecimentoSaude
        } else {
          this.messageAlert = 'Nenhuma equipe encontrada'
        }
      } catch (error) {
        console.log(error)
      } finally {
        this.loading = false
      }
    },
    clearMessageAlert() {
      this.messageAlert = ''
    },
  },
}
</script>

<style scoped lang="scss">
#adicionar-equipe {
  margin: 20px;
}
</style>
